import React, {useEffect, useMemo} from 'react';
import _ from 'lodash';
import {Button, Card, Col, Form, Row,} from 'react-bootstrap';
import {PlusLg} from 'react-bootstrap-icons';
import Select from 'react-select';

import useToast from '../../../hooks/useToast';
import Required from '../../Required';
import AddSelection from "./AddSelection";
import HintCard from "../../common/HintCard/HintCard";
import SelectInput from "../../SelectInput/SelectInput";
import FakeRequiredInput from "../../common/FakeRequiredInput";
import {dateRenderer} from "../../../services/formatSvc";
import moment from "moment";

export default function IndexCard({
  children,
  data: { data, type, projectStatus }, periods, onChange, placeholder, isPortfolioProject, projTypeId, fixedPcs, disabled
}) {
  const modifiedYears = useMemo(() => periods.filter((p) => !p.isClosed).map((p) => ({ value: p.year, label: p.year })), [periods]);
  const modifiedYearsArray = useMemo(() => modifiedYears?.map(x=>x?.value), [modifiedYears]);
  const addToast = useToast();

  const addCard = () => {
    const lastId = filterLastId()
    const newId = lastId === undefined ? 0 : lastId - 1;
    onChange(data.concat([{
      id: newId, name: '', unit: '', isKey: false, values: [],
    }]), 'pcs');
  };

  const filterLastId = () =>
    data
      .filter((d) => d.id <= 0)
      .map((d) => d.id)
      .sort((a, b) => a - b)[0];

  const addFixedPcsCard = (items) => {
    const lastId = filterLastId();
    const newId = lastId === undefined ? 0 : lastId - 1;
    const concatArr = [];

    const itemToDelete = data.find((d) => d.fixedPcId && !items.includes(d.fixedPcId));
    const fixedPcForItem = itemToDelete ? fixedPcs.find((f) => f.id === itemToDelete.fixedPcId) : null;
    if (itemToDelete && (itemToDelete.parentPcId && fixedPcForItem.isActiveForProj || itemToDelete.values?.length > 0)) {
      addToast.error(itemToDelete.parentPcId && fixedPcForItem.isActiveForProj
        ? 'Данный показатель наследуется от портфеля и действует в течение срока реализации проекта'
        : 'По показателю заведены планы');
    } else {
      items.reduce((acc, item) => {
        if (data.some((x) => !!x.fixedPcId && x.fixedPcId === item)) return acc;
        const pcsItem = fixedPcs.find((x) => x.id === item);
        concatArr.push({
          id: acc,
          fixedPcId: pcsItem.id,
          required: pcsItem.required,
          name: pcsItem.name,
          unit: pcsItem.unit,
          parentPcId: pcsItem.parentPcId,
          parentPcOriginId: pcsItem.parentPcOriginId,
          isKey: !!pcsItem.isKey,
          isNew: true,
          values: [],
        });
        return acc - 1;
      }, newId);
      const a = data.filter((x) => (x.fixedPcId && items.includes(x.fixedPcId)) || !x.fixedPcId).concat(concatArr);
      onChange(a);

      // onChange(data.concat([{
      //   id: newId, fixedPcId:item.id, required:item.required, name: item.name, isNew:true, unit: item.unit, isKey: false, values: [],
      // }]), 'pcs');
    }
  };



  const deleteCard = (itemId) => {
    const itemToDelete = data.find((d) => d.id === itemId);
    if (itemToDelete) {
      const itemContainsClosedPeriods = itemToDelete.values?.some((v) => !modifiedYears.find((y) => y.value === v.year));
      if (itemToDelete && !itemContainsClosedPeriods) onChange(data.filter((d) => d.id !== itemId), 'pcs');
      else addToast.error('Нельзя удалить (показатель содержит данные по закрытым периодам)');
    }
  };

  const deleteFixedCards = (newCards) => {
    onChange(newCards)

  }
  // const addFixedCards = (newCards,newId) => newCards.reduce((acc,item)=>onChange(data.concat([{
  //   id: newId, fixedPcId:item.id, required:item.required, name: item.name, unit: item.unit, isKey: false, values: [],
  // }]), 'pcs'),newId-1)

  const addFixedCards = (newCards,newId,deletedPcs)=>{
    const concatArr = []
    newCards.reduce((acc,item)=> concatArr.push({
      id: acc?.id ? acc.id - 1 : acc - 1,
      fixedPcId: item.id,
      required: item.required,
      name: item.name,
      unit: item.unit,
      isKey: false,
      isNew:true,
      values: []
    }),newId)
    onChange(deletedPcs.length ? deletedPcs.concat(concatArr) : data.filter(x=>!x?.fixedPcId).concat(concatArr))
  }



  const getYears = (pcVals) => (pcVals && pcVals.length > 0
    ? pcVals.map((v) => ({ value: v.year, label: v.year }))
    : []);

  const handleYearChange = (item, selYears) => {
    let newValues = [];
    // remove step
    newValues = item?.values?.filter((v) => {
      const foundInNewArray = selYears.find((y) => y.value === v.year);
      if (foundInNewArray) return true;
       const isAllowedToRemove = periods.find((p) => p.year === v.year && !p.isClosed);
      if (isAllowedToRemove) return false;
      addToast.error(`Нельзя удалить показатель за ${v.year} - данный период закрыт`);
      return true;
    }) ?? [];

    // add step
    for (const y of selYears) {
      const alreadyExist = newValues?.find((v) => v.year === y.value);
      if (!alreadyExist) newValues?.push({ year: y.value, plan: '' });
    }

    // if (item.values.length > 0) {
    //   newValues = selYears.map(y =>
    //     item.values.find(v => v.year === y.value) ||
    //     { year: y.value, plan: ''}
    //   )
    //   // selYears.forEach(y => {
    //   //   let oldValue = item.values.find(v => v.year === y.value);
    //   //   newValues.push(oldValue || { year: y.value, plan: ''});
    //   // });
    // }
    // else {
    //   newValues = selYears.map(y => ({ year: y.value, plan: ''}));
    // }
    // newValues = selYears.map(y =>
    //   item.values.find(v => v.year === y.value) ||
    //   { year: y.value, plan: ''}
    // )
    newValues = newValues?.sort((a, b) => a.year - b.year);
    onPcItemChange(item.id, newValues, 'values');
  };


  const onPcItemChange = (itemId, value, field) => {
    const dataCopy = [...data];
    const changedItem = dataCopy.find((d) => d.id === itemId);
    changedItem[field] = value;
    onChange(dataCopy, 'pcs');
  };

  const onPcItemValChange = (item, year, value) => {
    const newValues = [...item?.values];
    const changedVal = newValues?.find((v) => v.year === year);
    changedVal.plan = value;
    onPcItemChange(item.id, newValues, 'values');
  };

  const getYearsOptions = (item) => {
    const fixedElement = item?.fixedPcId && fixedPcs?.find(x=>x.id===item.fixedPcId)
    // if (!isPortfolioProject) return modifiedYears;
    return fixedElement
        ? modifiedYears.filter(el=> {
          const checkStartDate = fixedElement?.startDate && el.value >=moment(fixedElement.startDate).year()
          const checkEndDate = el.value <= moment(fixedElement.endDate).year()
          if (!fixedElement?.endDate){
            return checkStartDate
          }
          return checkStartDate && checkEndDate
        })
        : modifiedYears.filter(yearOpt => !item.inactive  || yearOpt.value < item.inactive)
    // return periods.filter((p) => !p.isClosed && (!item.presetYears || item.presetYears.includes(p.year))).map((p) => ({ value: p.year, label: p.year }));
  };

  const checkIncludesOfProjTypes = (element) => element.projTypes.map((x) => x.id).includes(projTypeId)
  const footerObject = {
    'pcs':(

            <Row>
              <Col  className={'col-auto'}>
                <Button onClick={addCard} disabled={disabled} variant="outline-primary">
                  <PlusLg className="me-1 mb-1" />
                  Добавить показатель
                </Button>
              </Col>
              <Col>
                {`Вы можете добавить ${!isPortfolioProject ? 'неунифицированные' : ''} показатели в паспорт, заполнив форму`}
              </Col>
            </Row>
    ),
    'fixedPcs': (<AddSelection
        disabled={disabled}
      options={fixedPcs
        ?.sort((a, b) => {
          // сначала идут действующие по типу, затем не действующие в порядке возрастания даты окончания

          if (!a.isTermOver && b.isTermOver) return -1;
          else if (a.isTermOver && !b.isTermOver) return 1;
          else if ((!a.endDate || a.endDate < b.endDate) && (checkIncludesOfProjTypes(a) && !checkIncludesOfProjTypes(b))) return -1;
          else if ((!b.endDate || a.endDate > b.endDate) && (!checkIncludesOfProjTypes(a) && checkIncludesOfProjTypes(b))) return 1;
          else return 0;
        })
        .map((k) => ({
          key: k.id,
          text: k.name,
          label: <p>{k.name} {k.endDate ? ` (до ${dateRenderer(k.endDate)}) ` : ''}{k?.projTypes?.length!==0 && <span style={{ color: '#EA7306' }}>{k.projTypes?.map((x) => x?.name).join(', ')}</span>}</p>,
          readonly: k.isTermOver,
        }))}
      selectedValues={data?.filter((x) => x?.fixedPcId).map((x) => x.fixedPcId)}
      addButtonLabel="Добавить показатель"
      isNotDefault={true}
      title="Унифицированные показатели"
      onChange={(pcs) => addFixedPcsCard(_.uniq(pcs))}
    />),
  };

  const userCard = () =>{
    const currData = type === 'pcs' ? data.filter(x=>!x.fixedPcId) : type==='fixedPcs' ? data.filter(x=>!!x.fixedPcId && !Number.isNaN(x.id)) : []
    return (
        <>
          {!currData.length && type==='fixedPcs' && fixedPcs && fixedPcs?.some(x=>x.projTypes.map(y=>y.id).includes(projTypeId))  && <HintCard text={"Вам необходимо запланировать хотя бы 1 показатель из числа унифицированных для выбранного типа проекта"}/>}
          {currData.map((item, index) => {
            const isItemHasNotDisabledYears = item.values.map(x=>x.year).every((e)=>modifiedYearsArray.includes(e))
            const isTermOver = fixedPcs?.find((e) => e.id === item.fixedPcId)?.isTermOver;
            const isActiveForProj = fixedPcs?.find((e) => e.id === item.fixedPcId)?.isActiveForProj;

            return <Row key={item.id}>
              <Form.Group as={Col}>
                <Card className="mb-4">
                  <Card.Header style={type === 'pcs' ? cardHeaderStyling : type === 'fixedPcs' ? cardHeaderForFixedPcsStyling : {}}>
                    {data.length > 1 && (!isPortfolioProject || !isActiveForProj) && <Button onClick={() => deleteCard(item.id)} variant="light" className="btn-close" size="sm" />
                    }
                  </Card.Header>
                  <Card.Body>
                    <Row className="mb-4">
                      <Form.Group as={Col}>
                        <Form.Label>
                          Наименование показателя
                          <Required />
                        </Form.Label>
                        <Form.Control
                            placeholder={placeholder}
                            required
                            as="textarea"
                            rows={3}
                            value={item.name}
                            disabled={isPortfolioProject || type==='fixedPcs' || !isItemHasNotDisabledYears || disabled}
                            onChange={(e) => onPcItemChange(item.id, e.target.value, 'name')}
                        />
                        <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} md={type === 'pcs' ? '4' : '5'}>
                        <Form.Label>
                          Единицы измерения
                          <Required />
                        </Form.Label>
                        <Form.Control
                            type="text"
                            required
                            value={item.unit}
                            disabled={isPortfolioProject || type==='fixedPcs' || !isItemHasNotDisabledYears || disabled}
                            onChange={(e) => onPcItemChange(item.id, e.target.value, 'unit')}
                        />
                        <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md={type === 'pcs' ? '4' : '5'}>
                        <Form.Label>
                          Год
                          <Required />
                        </Form.Label>
                        <div>
                          <SelectInput
                              selectKey={index}
                              placeholder=""
                              disabled={type==='fixedPcs' && isTermOver || disabled}
                              // defaultValue={getYears(item.values)}
                              required
                              isMulti
                              name="yearsMulti"
                              defaultOptions={getYearsOptions(item)}
                              onChange={(selYears) => handleYearChange(item, selYears)}
                              value={getYears(item?.values)}
                              closeMenuOnSelect={false}
                          />
                        </div>
                        <Form.Control.Feedback type="invalid">Выберите год</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md='2'>
                        <Form.Label>Ключевой </Form.Label>
                        <Form.Check
                            checked={item.isKey}
                            disabled={isPortfolioProject || disabled}
                            onChange={(e) => onPcItemChange(item.id, e.target.checked, 'isKey')}
                        />
                        <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                      </Form.Group>
                      {!isPortfolioProject && type === 'pcs' && <Form.Group as={Col} md="2">
                        <Form.Label>Недействующий </Form.Label>
                        <Form.Check
                          checked={!!item.inactive}
                          disabled={disabled || !['returnedByHeadSP', 'draft'].includes(projectStatus)}
                          onChange={(e) => onPcItemChange(item.id, e.target.checked ? (new Date()).getFullYear() : null, 'inactive')}
                        />
                        <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                      </Form.Group>}
                    </Row>
                    <Row>
                      {item?.values
                          ?.sort((a, b) => a.year - b.year)
                          ?.map((val, i) => (
                              <>
                                {i === 0 && <Form.Label className="mt-4">Значение показателя</Form.Label>}
                                <Form.Group as={Col} md="1" key={val.year}>
                                  <Form.Label>
                                    {val.year}
                                    {' '}
                                    <Required />
                                  </Form.Label>
                                  <Form.Control
                                      type="text"
                                      required
                                      value={val.plan}
                                      readOnly={
                                        !modifiedYears.find((y) => y.value === val.year) ||
                                        (item.inactive && val.year >= item.inactive) ||
                                        disabled ||
                                        (isPortfolioProject && isTermOver)
                                      }
                                      onChange={(e) => onPcItemValChange(item, val.year, e.target.value)}
                                  />
                                </Form.Group>
                              </>
                          ))}
                    </Row>
                  </Card.Body>
                </Card>
              </Form.Group>
            </Row>
          })}
          { (
             footerObject.hasOwnProperty(type) && footerObject[type]
          )}
        </>
    );
  }



  return userCard()
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end', minHeight: 38,
};
const cardHeaderForFixedPcsStyling={
  display: 'flex', justifyContent: 'end', minHeight: 38,

}
